module.exports = __webpack_public_path__ + "47e6ec3887664851a9d4c1cdeb9f7ce7.pdf";